import React from "react";
import IMAGES from "@/public/assets/img";
import Image from "next/image";

const features = [
  {
    icon:  IMAGES.termsheet.realTime,
    title: "Real Time Credit Check",
    description: "Instant insights into your buyer’s financial credibility.",
  },
  {
    icon:  IMAGES.termsheet.document,
    title: "Detailed Reports",
    description: "Gain a comprehensive view of payment history.",
  },
  {
    icon:  IMAGES.termsheet.analysis,
    title: "In-Depth Analysis",
    description: "Our cutting-edge technology ensures accuracy.",
  },
];

const ExporterCredlix = () => {
  return (
    <section className="bg-yellow-400 py-[100px]">
      <div className="container xm:px-2 px-3">
        <div className="flex justify-between w-full gap-3 sm:flex-col">
          <div className="w-2/5 sm:w-full">
            <h2 className="text-xxl font-bold sm:text-xxl  text-brand">
              Why Every Indian <br /> Exporter Needs Credlix
            </h2>
            <p className="mt-2 text-gray-800 text-lg">
              Credlix offers real-time, detailed, and in-depth analysis. You can
              instantly check creditworthiness of your clients and make smarter
              business decisions with our global database.
            </p>
          </div>

          <div className="flex sm:flex-row flex-wrap gap-2 w-3/5 sm:w-full sm:mt-6">
            {features.map((feature, index) => (
              <div
                key={index}
                className="bg-white rounded-2xl p-3 shadow-md w-[30%] sm:w-full"
              >
                <Image
                  src={feature.icon}
                  alt={feature.title}
                  width={60}
                  height={60}
                  className="mb-1"
                />
                <h3 className="font-semibold text-lg text-gray-900 mb-2 max-h-12">
                  {feature.title}
                </h3>
                <p className="text-gray-600 text-base">{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ExporterCredlix;
